export default __webpack_public_path__ + "b665882de9ff1b3d9bc99e5e7ba07fa7.png";